import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import FormInstance from 'forms/form-instance/FormInstance';
import FormInstanceTabState from 'forms/form-instance/FormInstanceTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class FormInstanceTabView extends BufferTabView<FormInstanceTabState> {
  render(): this {
    const props = {
      formDefinitionId: this.model.get('formDefinitionId'),
    };
    renderToDOM(<FormInstance {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<FormInstanceTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

FormInstanceTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
